import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=17ef82b4&scoped=true"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=17ef82b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ef82b4",
  null
  
)

export default component.exports